<template>
  <div class="m-k">
    <div class="m-k__head">
      <div class="m-k__tabs">
        <a  v-for="key in ['yandex', 'ozon', 'wb', 'sber']"
            href="javascript:void(0);"
            class="m-k__tab"
            :style="{ pointerEvents: loading ? 'auto' : 'none' }"
            @click="setMp($event, key)"
        >
          {{ key}}
        </a>
      </div>
      <div class="mk__search">
          <input type="text" v-model="query">
      </div>
    </div>

    <div class="load _visible" v-if="!loading">
      <hr/><hr/><hr/><hr/>
    </div>

    <div :class="['m-k__items', { '_search': query }]">
      <TheTopLine/>

      <div v-for="producer in iterableData()"
           class="m-k__producer"
      >
        <TheProducerLine :producer="producer"/>

        <div class="m-k__models">
          <div v-for="model in this.objectToArray(producer)" class="m-k__model">
            <TheModelLine :model="model" :producer="producer"/>
            <div class="m-k__offers">
<!--              <div class="m-k__row m-k__row_offer" v-for="offer in objectToArray(model)"-->
<!--                   :class="[getOfferModifiersClass(offer.viewModifiers), { '_matched': offer.isOpen }]"-->
<!--              >-->
<!--                <TheOfferLine :offer="offer" :model="model" :producer="producer"/>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {useMarkupsStore} from "../../stores/markups";
import {mapActions, mapWritableState} from "pinia";
import TheTopLine from "./TheTopLine.vue";
import {markupsMixin} from "../../mixins/markupsMixin";
import TheProducerLine from "./TheProducerLine.vue";
import TheModelLine from "./TheModelLine.vue";
import TheOfferLine from "./TheOfferLine.vue";

export default {
  name: "TheMarkups",
  components: {TheOfferLine, TheModelLine, TheProducerLine, TheTopLine},
  mixins: [markupsMixin],
  computed: {
    ...mapWritableState(useMarkupsStore, [
        'data',
        'query',
        'selectedColumns',
        "loading"
    ]),
  },
  mounted() {
    useMarkupsStore().fetchAll();
  },
  methods: {
    ...mapActions(useMarkupsStore, ['modifySelectedColumns']),
    getOfferModifiersClass(modifiers) {
      const result = []
      modifiers.forEach((e) => {
        result.push('_' + e);
      })

      return result;
    },
    iterableData() {
      const cleanData = this.objectToArray(this.data.markups);
      if (this.query && cleanData && cleanData.length > 0) {
        const filteredData = [];
        cleanData.forEach((producer) => {
          const producerName = producer.name
          this.objectToArray(producer).forEach((model) => {
            const modelName = model.modelName;
            this.objectToArray(model).forEach((offer) => {
              const offerName = offer.offer.title;
              const fullName = [producerName, modelName, offerName].join(' ');
              if (this.hasIntersection(this.query, fullName)) {
                if (!filteredData.some((e) => e.id === producer.id)) {
                  filteredData.push(producer);
                  offer.isOpen = true;
                }
              }
            })
          })
        })

        return filteredData;

      } else {
        return cleanData;
      }
    },
    hasIntersection(a, b) {
      return b.toLowerCase().includes(a.toLowerCase());
    },
    setMp(event, key) {
      const link = event.target;
      link.classList.toggle('_selected')
      this.modifySelectedColumns(key)

      if (this.selectedColumns.length === 0) {
        this.data.columns.forEach((e) => {
          e.disable = false
        })
      } else {
        this.data.columns.forEach((e) => {
          const isSelected = this.selectedColumns.includes(e.marketplaceKey);
          e.disable = !isSelected;
        })
      }
    }
  },
}
</script>